module.exports = __webpack_public_path__ + "static/media/4.a6e9a3b7.JPG";